export interface PriceSimulationStatusOption {
    id: string;
    nameKey: string;
}

export const PriceSimulationStatus: PriceSimulationStatusOption[] = [
    { id: 'All', nameKey: 'priceSimulation.statusAll' },
    { id: 'NotHandled', nameKey: 'priceSimulation.statusNotHandled' },
    { id: 'Draft', nameKey: 'priceSimulation.statusDraft' },
    { id: 'Kept', nameKey: 'priceSimulation.statusKept' },
    { id: 'PendingReview', nameKey: 'priceSimulation.statusPendingReview' },
    { id: 'Approved', nameKey: 'priceSimulation.statusApproved' },
    { id: 'Rejected', nameKey: 'priceSimulation.statusRejected' },
];
